function loadFonts() {
  Array.prototype.forEach.call(document.querySelectorAll('link.fontstylesheet'), function (link) {
    link.rel = 'stylesheet';
  });
}

module.exports = {
  loadFonts: loadFonts
};



//////////////////
// WEBPACK FOOTER
// ./src/js/helpers/fontstylesheet.js
// module id = 51
// module chunks = 0